// extracted by mini-css-extract-plugin
export default {"tableSection":"UWTable_tableSection__g+iWp"};